import { InformationForm } from "@/features/information/components/InformationForm";
import { useInformationListSessionStorage } from "@/hooks/useInformationListSessionStorage";

import { FC, useMemo } from "react";

type TInformationCreatePageProps = {};

export const InformationCreatePage: FC<TInformationCreatePageProps> = () => {
  const { getBackUrl } = useInformationListSessionStorage();
  const backUrl = useMemo(() => getBackUrl(), [getBackUrl]);

  return <InformationForm backUrl={backUrl} />;
};
